"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const mainData_1 = __importDefault(require("./mainData"));
const litigationLogFlowConfig_1 = require("../../log/litigationLogFlowConfig");
exports.default = (0, vue_1.defineComponent)({
    name: 'AssignRule',
    components: {
        ListView: ListView_1.default
    },
    data() {
        return {
            mainData: mainData_1.default
        };
    },
    computed: {
        width() {
            return this.getWidth();
        },
        choiceList() {
            return this.mainData.$module.choice.getList();
        },
        listOption() {
            return {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {},
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    },
                    {
                        prop: 'export',
                        name: '导出',
                        type: 'primary'
                    }
                ],
                menu: {
                    list: [
                        {
                            prop: 'litigation',
                            name: '发起诉讼',
                            hidden({ record }) {
                                // 审批状态 = 通过
                                if (record.litigationApplyStatus.value === '2') {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        }
                    ]
                },
            };
        }
    },
    mounted() {
        this.mainData.$loadData(true);
    },
    beforeUnmount() {
        mainData_1.default.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onMenu(from, prop, payload) {
            if (from === 'table') {
                if (prop === 'litigation') {
                    (0, litigationLogFlowConfig_1.toLitigationLog)('build', 'start', payload.record.id);
                }
            }
        }
    }
});
